module.exports = __webpack_public_path__ + "img/swiper-6.23a1158.png";